import { useRef } from 'react';

import { useAddToCart } from '@/entities/cart';
import { clearErrors, handleSubmit } from '@/entities/purchase-form';

import { useTrackEventAddToCart } from '../analytics';
import { useOnSuccessAddToCart } from '../success';
import { useAddToCartOnError } from '../useAddToCartOnError';
import { useNormalizeData } from '../useNormalizeData';

export const useAddToCartSubmit = () => {
    const submitPromiseRef = useRef<Promise<void> | null>(null);
    const { trackEvent } = useTrackEventAddToCart();

    const { onAddToCartError: onError } = useAddToCartOnError();
    const { onSuccess } = useOnSuccessAddToCart();

    const normalizeData = useNormalizeData();
    const { mutateAsync: addToCartMutation } = useAddToCart({ onSuccess, onError, isProductRecommendation: false });

    const submitHandler = handleSubmit(async data => {
        if (submitPromiseRef.current) {
            await submitPromiseRef.current;
            return;
        }

        const submitPromise = (async () => {
            clearErrors();

            const normalizedData = normalizeData(data);
            if (!normalizedData) {
                return;
            }

            trackEvent();

            await addToCartMutation([normalizedData]);
        })();

        submitPromiseRef.current = submitPromise;

        try {
            await submitPromise;
        } finally {
            if (submitPromiseRef.current === submitPromise) {
                submitPromiseRef.current = null;
            }
        }
    });

    return { submitHandler };
};
